import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PractitionerListScreen } from 'screens/practitioner';

export default withPermissions(PractitionerListScreen, [
  GroupSecurity.PractitionerRead,
]);
